import {
  AdvancedMarker,
  InfoWindow,
  Pin,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";
import LocationPopUp from "../common/LocationPopUp";
import React, { useCallback, useState } from "react";

const LocationMarker = ({
  position,
  type,
  locId,
  jobId,
  typeName,
  locName,
  unvisited,
  unvisitedIndex,
  key,
  simpleMode = false,
}) => {
  const [markerRef, marker] = useAdvancedMarkerRef();
  const [infoWindowShown, setInfoWindowShown] = useState(false);

  const handleMarkerClick = useCallback(() => {
    setInfoWindowShown((isShown) => !isShown);
  }, []);

  const handleClose = useCallback(() => {
    setInfoWindowShown(false);
  }, []);

  let pin = <Pin />;

  switch (type) {
    case 1: {
      pin = (
        <div>
          {simpleMode && (
            <div
              style={{
                position: "absolute",
                top: "-30px",
                left: "0",
                translate: "-40% 0",
                padding: "5px",
                backgroundColor: "rgba(255, 255, 255, 1)",
                textAlign: "center",
                width: "80px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              {locName}
            </div>
          )}

          <Pin
            background={"#1E90FF"}
            borderColor={"#0000CD"}
            glyphColor={"#87CEFA"}
          >
            {simpleMode && <div style={{ color: "#000000" }}>{locName}</div>}
          </Pin>
        </div>
      );
      break;
    }
    case 2: {
      pin = (
        <div>
          {simpleMode && (
            <div
              style={{
                position: "absolute",
                top: "-30px",
                left: "0",
                translate: "-40% 0",
                padding: "5px",
                backgroundColor: "rgba(255, 255, 255, 1)",
                textAlign: "center",
                width: "80px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              {locName}
            </div>
          )}
          <Pin
            background={"#32CD32"}
            borderColor={"#006400"}
            glyphColor={"#98FB98"}
          >
            {simpleMode && <div style={{ color: "#000000" }}>{locName}</div>}
          </Pin>
        </div>
      );
      break;
    }
    case 3: {
      pin = (
        <div>
          {simpleMode && (
            <div
              style={{
                position: "absolute",
                top: "-30px",
                left: "0",
                translate: "-40% 0",
                padding: "5px",
                backgroundColor: "rgba(255, 255, 255, 1)",
                textAlign: "center",
                width: "80px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              {locName}
            </div>
          )}
          <Pin
            background={"#FFD700"}
            borderColor={"#FFA500"}
            glyphColor={"#FFFF00"}
          >
            {simpleMode && <div style={{ color: "#000000" }}>{locName}</div>}
          </Pin>
        </div>
      );
      break;
    }
    case 4: {
      pin = (
        <div>
          {simpleMode && (
            <div
              style={{
                position: "absolute",
                top: "-30px",
                left: "0",
                translate: "-40% 0",
                padding: "5px",
                backgroundColor: "rgba(255, 255, 255, 1)",
                textAlign: "center",
                width: "80px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              {locName}
            </div>
          )}
          <Pin
            background={"#32CD32"}
            borderColor={"#006400"}
            glyphColor={"#1E90FF"}
          >
            {simpleMode && <div style={{ color: "#000000" }}>{locName}</div>}
          </Pin>
        </div>
      );
      break;
    }

    default:
  }

  return (
    <>
      {simpleMode ? (
        <>
          <AdvancedMarker
            key={key}
            title={typeName}
            ref={markerRef}
            position={position}
            onClick={handleMarkerClick}
          >
            {pin}
          </AdvancedMarker>
          {/*<InfoWindow*/}
          {/*  anchor={marker}*/}
          {/*  onCloseClick={handleClose}*/}
          {/*  style={{ maxHeight: "10px" }}*/}
          {/*  disableAutoPan={true}*/}
          {/*>*/}
          {/*  {locName}*/}
          {/*</InfoWindow>*/}
        </>
      ) : (
        <>
          <AdvancedMarker
            key={key}
            title={typeName}
            ref={markerRef}
            position={position}
            onClick={handleMarkerClick}
          >
            {pin}
          </AdvancedMarker>
          {infoWindowShown && (
            <InfoWindow anchor={marker} onCloseClick={handleClose}>
              <LocationPopUp
                key={key}
                locId={locId}
                jobId={jobId}
                unvisited={unvisited}
                unvisitedIndex={unvisitedIndex}
              />
            </InfoWindow>
          )}
        </>
      )}
    </>
  );
};

export default LocationMarker;
